import { render, staticRenderFns } from "./Students.vue?vue&type=template&id=52e2c33a&"
import script from "./Students.vue?vue&type=script&lang=js&"
export * from "./Students.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e2c33a')) {
      api.createRecord('52e2c33a', component.options)
    } else {
      api.reload('52e2c33a', component.options)
    }
    module.hot.accept("./Students.vue?vue&type=template&id=52e2c33a&", function () {
      api.rerender('52e2c33a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Settings/Students/Students.vue"
export default component.exports